document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-role="search-form-category-button"]');
  const closeButton = document.querySelector('[data-role="search-form-close-button"]');
  const popup = document.querySelector('[data-role="search-form-popup"]');
  const contents = document.querySelectorAll('[data-role="search-form-content"]');

  if (!buttons.length || !closeButton || !popup || !contents.length) return;

  // popupの状態を変更する
  const setPopupActiveState = (state) => {
    popup.dataset.isActive = state;
  };

  // buttonの状態を変更する
  const setButtonActiveState = (button, state) => {
    button.dataset.isActive = state
  };

  // popup内コンテンツの状態を変更する
  const setContentActiveState = (content, state) => {
    content.dataset.isActive = state;
  };

  // すべてのbuttonの状態を変更する
  const setAllButtonsState = (buttons, state) => {
    buttons.forEach((button) => {
      setButtonActiveState(button, state)
    })
  }

  // popupの表示位置(top)を定義する
  const calculatePopupPosition = (buttonElement, margin = 10) => {
    const { height, top } = buttonElement.getBoundingClientRect();
    return height + top + margin + window.scrollY;
  };

  // popupのstyleにtopの値を適用させる
  const setPopupPosition = (popup, position) => {
    popup.style.top = `${position}px`;
  };

  const toggleContent = (buttonId) => {
    setPopupActiveState('true');
    contents.forEach((content) => {
      const isActive = content.dataset.id === buttonId ? 'true' : 'false';
      setContentActiveState(content, isActive)
    });
  };

  // 非表示にする処理
  let currentResizeHandler = null; // リサイズイベントのハンドラを保持する変数

  const hidePopup = () => {
    setPopupActiveState('false');
    setAllButtonsState(buttons, 'false');

    // リサイズイベントのリスナーを削除
    if (currentResizeHandler) {
      window.removeEventListener('resize', currentResizeHandler);
      currentResizeHandler = null; // ハンドラをリセット
    }

    contents.forEach((content) => {
      setContentActiveState(content, 'false')
    });
  }

  const setupButtonEventListeners = () => {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        // トグル
        const isAlreadyActive = button.dataset.isActive === 'true';
        if (popup.dataset.isActive === 'true' && isAlreadyActive) {
          hidePopup();
          return;
        }

        // ポップアップを非表示にする際に以前のリサイズハンドラを削除
        if (currentResizeHandler) {
          window.removeEventListener('resize', currentResizeHandler);
        }

        setAllButtonsState(buttons, 'false')
        setButtonActiveState(button, 'true')
        toggleContent(button.dataset.id)
        setPopupPosition(popup, calculatePopupPosition(button))

        // 新しいリサイズハンドラを設定し、currentResizeHandlerに保持
        currentResizeHandler = () => {
          setPopupPosition(popup, calculatePopupPosition(button))
        }
        window.addEventListener('resize', currentResizeHandler);
      })
    })
  }

  setupButtonEventListeners();

  // 閉じるボタンクリック時の処理
  closeButton.addEventListener('click', () => {
    hidePopup();
  });

});
